/**
 * Thrown when a browser action is cancelled because its caller's `AbortSignal`
 * fired (typically the per-tool timeout from `withToolTimeout`, or a
 * pre-aborted signal handed to `BrowserToolExecutor.withCallSignal`).
 *
 * Identify with `instanceof ToolAbortedError`.
 */
export class ToolAbortedError extends Error {
  constructor(stage: string) {
    super(`Browser action aborted at stage: ${stage}`);
    this.name = 'ToolAbortedError';
  }
}
